import _ from 'lodash';
import React, { Component } from 'react';
import update from 'immutability-helper';
import { DatePicker } from 'antd';
import moment from 'moment';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';

import i18n from '../../config/i18n';
import connectActionsAndReducers from '../../toolbox/connectActionsAndReducers';
import Input from '../../components/shared/Input';
import Modal from '../../components/shared/Modal';
import InputFile from '../../components/shared/InputFile';
import Link from '../../components/shared/Link';
import roleFields from './RoleFieldsMapping';
import { FIRST_NAME,
  LAST_NAME,
  PHONE,
  D_O_B,
  SSN,
  TITLE_ID,
  SPECIALTY_ID,
  MEDICAL_GROUP_ID,
} from '../../constants/ProfileFields';
import { DATE_OF_BIRTH_FORMAT } from '../../constants/DateOfBirthFormat';
import {
  UserAPIConnectors,
} from '../../api/index';
import Image from '../../components/shared/Image';

// default avatar images
import defaultAvatarImage from '../../styles/images/no_avatar_image.png';

const styles = {
  root: { padding: 0 },
  inner: { padding: '20px 30px', marginBottom: 0 },
  form: { marginTop: 25 },
  link: {
    textDecoration: 'none',
    color: 'inherit',
  },
  image: {
    width: 400,
    height: 400,
    objectFit: 'cover',
  },
  avatar: {
    container: {
      maxWidth: 400,
      minHeight: 400,
      position: 'relative',
      margin: '10px auto',
    },
    layer: {
      borderRadius: '8px',
      boxSizing: 'border-box',
      height: '100%',
      left: '0',
      position: 'absolute',
      top: '0',
      width: '100%',
    },
    overlay: {
      background: '#000',
      opacity: '.5',
      msFilter: 'alpha(opacity=50)',
    },
    content: {
      position: 'absolute',
      top: 0,
      width: '100%',
      height: '100%',
      cursor: 'pointer',
      color: '#fff',
      fontSize: '21px',
      fontWeight: 'bold',
      lineHeight: '24px',
      padding: '0px 15px 0 15px',
      paddingTop: '40%',
      textAlign: 'center',
      textShadow: '0 1px 3px rgba(0,0,0,0.75)',
      camera: {
        fontSize: 35,
      },
    },
    hint: {
      color: '#d52626',
      fontSize: '18px',
      marginTop: '12px',
      textAlign: 'center',
    },
  },
  button: {
    uploadImage: {
      position: 'absolute',
      visibility: 'hidden',
    },
    saveProfile: {
    },
    cancel: {
      marginRight: 10,
    },
    changePassword: {
      textAlign: 'center',
      marginTop: '5px',
    },
  },
  slot: {
    group: {
      display: 'flex',
    },
    title: {
      color: 'gray',
      fontSize: 18,
      fontWeight: 'bold',
      lineHeight: '45px',
    },
    value: {
      fontSize: 18,
    },
    select: {
      textIndent: 10,
      fontSize: 18,
    },
    required: {
      position: 'relative',
      content: '*',
      color: 'red',
      right: 5,
      top: 5,
    },
  },
  preview: {
    button: {
      marginTop: 10,
      width: '100%',
    },
    image: {
      maxHeight: '400px',
    },
  },
  profile: { margin: '0px 15px' },
};

const InputRow = props => (
  <div className="form-group clearfix">
    <div className="col-xs-12 col-sm-12 col-md-4" style={styles.slot.title}>
      { props.required &&
        <span style={styles.slot.required}>*</span>
      }
      {i18n.t(props.label)}
    </div>
    <div className="col-xs-12 col-sm-12 col-md-8">
      {props.children}
    </div>
  </div>
);
class EditProfileContainer extends Component {
  constructor(props) {
    super(props);
    const { user: { profile } } = props;
    const initProfile = _.isEmpty(profile)
      ? {
        firstName: '',
        lastName: '',
        phone: '',
        titleId: undefined,
        specialtyId: undefined,
        medicalGroupId: undefined,
        dateOfBirth: '',
        ssn: '',
      }
      : profile;

    this.state = {
      titlesOptions: [],
      specialtiesOptions: [],
      groupsOptions: [],
      profile: initProfile,
      preview: {
        file: null,
        src: '',
        isVisible: false,
        crop: {},
      },
    };
  }

  componentDidMount() {
    // Allows us to receieve incoming props
    // Prevent error - Warning: setState(...): Can only update a mounted or mounting component.
    this.receieveIncomingProps = true;

    const {
      actions,
      user: { profile },
      metadata: { data },
    } = this.props;

    // Fetch metadata
    if (_.isEmpty(data)) {
      actions.getMetadata();
    }

    // Retrieve user profile
    if (_.isEmpty(profile)) {
      actions.getUserProfile();
    }

    // Init metadata for dropdown
    this.initMetadata();
  }
  componentWillUnmount() {
    // allows us to ignore incoming props
    this.receieveIncomingProps = false;
  }

  /* Form related binding. */
  onDateOfBirthChange = (e) => {
    this.setState({
      profile: update(
        this.state.profile,
        { dateOfBirth: { $set: e ? e.startOf('day').format(DATE_OF_BIRTH_FORMAT) : null } }
      ),
    });
  };
  onFormSelectChange = (e) => {
    const refName = e.target.name;
    const value = this[refName].value;
    const newProfile = _.assign({}, this.state.profile, { [refName]: value });
    this.setState({
      profile: update(this.state.profile, { $set: newProfile }),
    });
  };
  onFormValueChange = (value, element) => {
    const refName = element.name;
    const localValue = value ? value.trim() : value;
    const newProfile = _.assign({}, this.state.profile, { [refName]: localValue });
    this.setState({
      profile: update(this.state.profile, { $set: newProfile }),
    });
    return true;
  };
  onSelectFile = (file) => {
    this.createImage(file);
  };
  // trigger selecting file dialog
  onPreviewAvatar = (e) => {
    e.preventDefault();
    this.uploadImage.triggerClick();
    return false;
  };
  onUploadAvatar = async (e) => {
    e.preventDefault();

    // generate cropped image file,
    const file = await this.generateCroppedImage();
    if (!file) { return; }

    // upload photo
    const uploadPromise = this.uploadImage.fileUploadWrapper(
      file,
      UserAPIConnectors.uploadUserPhoto
    );
    uploadPromise
      .then(data => data)
      .finally(() => {
        this.setState({
          preview: update(this.state.preview, {
            isVisible: { $set: false },
          }),
        });
        this.props.actions.getUserProfile();
      });
  };
  onPreviewCancel = (e) => {
    e.preventDefault();
    this.setState({
      preview: update(this.state.preview, {
        file: { $set: null },
        src: { $set: '' },
        isVisible: { $set: false },
      }),
    });
  };
  onCancel = (e) => {
    e.preventDefault();
    const { router: { navigate } } = this.props;
    navigate('/profile', { trigger: true });
  };
  onSubmit = (e) => {
    e.preventDefault();
    const {
      actions,
      router,
    } = this.props;
    const hasChanged = this.compareChanges();

    // form data saved in this.state.profile
    if (hasChanged) {
      const {
        profile,
        profile: {
          roleId,
        },
      } = this.state;
      const userData = {};
      roleFields[roleId].fields.forEach((fieldName) => {
        userData[fieldName] = profile[fieldName];
      });

      // submit form
      UserAPIConnectors.updateUser(userData)
        .then(() => {
          actions.createSuccessAlert(i18n.t('updateProfileSucceedMsg_profile'));
          setTimeout(() => {
            actions.dismissLastAlert();
            router.navigate('/profile', { trigger: true });
          }, 2000);
        })
        .catch((err) => {
          actions.createDangerAlert(err.message);
        });
    } else {
      actions.createWarningAlert(i18n.t('noChangeMade'));
      setTimeout(() => {
        actions.dismissLastAlert();
      }, 2000);
    }
    return false;
  };

  initMetadata = (nextProps) => {
    const props = nextProps || this.props;
    const { metadata } = props;
    if (_.isEmpty(metadata.data) === false && this.receieveIncomingProps) {
      const localMetadata = metadata.data;
      const titlesData = (localMetadata.title || [])
        .filter(title => title.roleId === props.user.profile.roleId);
      const titlesOptions = this.generateSelectOpt(titlesData);
      const specialtiesData = localMetadata.specialty || [];
      const specialtiesOptions = this.generateSelectOpt(specialtiesData);
      const groupsData = localMetadata.medicalGroup || [];
      const groupsOptions = this.generateSelectOpt(groupsData);

      this.setState({
        specialtiesOptions,
        groupsOptions,
        titlesOptions,
      });
    }
    return metadata;
  };
  createImage = (file) => {
    const reader = new FileReader();
    reader.onload = () => {
      this.setState({
        preview: update(this.state.preview, {
          file: { $set: file },
          src: { $set: reader.result },
          isVisible: { $set: true },
        }),
      });
    };
    reader.readAsDataURL(file);
  };

  /* Component render helpers. */
  generateSelectOpt = data => (
    data.map(obj => (<option key={obj.name} value={obj.id}>{obj.name}</option>))
  );
  isButtonEnabled = () => {
    const roleId = this.state.profile.roleId;
    if (roleId) {
      const requiredFields = roleFields[roleId].requiredFields;
      return requiredFields.reduce((pre, cur) => pre && this.state.profile[cur], true);
    } return false;
  };
  compareChanges = () => {
    const { user: { profile: storeProfile } } = this.props;
    const editProfile = this.state.profile;
    return JSON.stringify(storeProfile) !== JSON.stringify(editProfile);
  };

  // Crop avatar
  handleImageLoaded = (image) => {
    const {
      height,
      width,
    } = image;
    const isWidthLarger = width > height;

    this.image = image;

    // Set the crop to the largest square and center it.
    this.setState({
      preview: update(this.state.preview, {
        crop: { $set: {
          aspect: 1,
          x: isWidthLarger ? (width - height) / 2 : 0,
          y: isWidthLarger ? 0 : (height - width) / 2,
          width: isWidthLarger ? height : width,
        } },
      }),
    });

    // Return false when setting crop state in here.
    return false;
  };

  generateCroppedImage = async () => {
    const image = this.image;
    const {
      createWarningAlert,
    } = this.props.actions;
    const {
      x,
      y,
      height,
      width,
    } = this.state.preview.crop;
    let file = null;

    if (image && width && height) {
      const canvas = document.createElement('canvas');
      const scaleX = image.naturalWidth / image.width;
      const scaleY = image.naturalHeight / image.height;
      const croppedWidth = width * scaleX;
      const croppedHeight = height * scaleY;

      // The maximum width & height (px) of the cropped image.
      // If the cropped image exceeds the max size then compress it.
      const maxWidth = 400;
      const maxHeight = 400;
      const compressScaleX = maxWidth / croppedWidth;
      const compressScaleY = maxHeight / croppedHeight;
      let finalCompressScale = compressScaleX < compressScaleY ? compressScaleX : compressScaleY;
      if (finalCompressScale > 1) { finalCompressScale = 1; }
      const compressWidth = croppedWidth * finalCompressScale;
      const compressHeight = croppedHeight * finalCompressScale;
      canvas.width = compressWidth;
      canvas.height = compressHeight;
      const ctx = canvas.getContext('2d');

      ctx.drawImage(
        image,
        x * scaleX,
        y * scaleY,
        croppedWidth,
        croppedHeight,
        0,
        0,
        compressWidth,
        compressHeight
      );

      file = await new Promise((resolve, reject) => {
        canvas.toBlob((blob) => {
          if (!blob) {
            createWarningAlert(i18n.t('cropPhotoFail'));
            reject();
          }
          resolve(new File(
            [blob],
            'avatar.jpg',
            { type: 'image/jpeg' }
          ));
        }, 'image/jpeg');
      });
    } else {
      createWarningAlert(i18n.t('cropPhotoFail'));
    }
    return file;
  };

  handleCropChange = (newCrop) => {
    this.setState({
      preview: update(this.state.preview, {
        crop: { $set: newCrop },
      }),
    });
  };

  render() {
    const {
      profile,
      preview,
      titlesOptions,
      specialtiesOptions,
      groupsOptions,
    } = this.state;
    const avatarOverlayStyle = _.assign({}, styles.avatar.layer, styles.avatar.overlay);

    // These are all available fields in user profile
    const allAvailableFields = {
      [FIRST_NAME]: options => (
        <InputRow label={'firstName'} required={options.required}>
          <Input
            name="firstName"
            placeholder={i18n.t('firstName')}
            value={profile.firstName || ''}
            style={styles.slot.value}
            validate={this.onFormValueChange}
          />
        </InputRow>
      ),
      [LAST_NAME]: options => (
        <InputRow label={'lastName'} required={options.required}>
          <Input
            name="lastName"
            placeholder={i18n.t('lastName')}
            value={profile.lastName || ''}
            style={styles.slot.value}
            validate={this.onFormValueChange}
          />
        </InputRow>
      ),
      [PHONE]: options => (
        <InputRow label={'phoneNumber'} required={options.required}>
          <Input
            name="phone"
            type="tel"
            placeholder={i18n.t('placeholder.phone')}
            value={profile.phone || ''}
            style={styles.slot.value}
            validate={this.onFormValueChange}
          />
        </InputRow>
      ),
      [D_O_B]: options => (
        <InputRow label={'d_o_b'} required={options.required}>
          <DatePicker
            name="dateOfBirth"
            value={profile.dateOfBirth ? moment(profile.dateOfBirth) : null}
            disabledDate={date => date && date > moment().endOf('day')}
            onChange={this.onDateOfBirthChange}
            required
          />
        </InputRow>
      ),
      [SSN]: options => (
        <InputRow label={'ssn'} required={options.required}>
          <Input
            name="ssn"
            type="string"
            placeholder={i18n.t('plzEnterSSNMsg')}
            value={profile.ssn || ''}
            style={styles.slot.value}
            validate={this.onFormValueChange}
          />
        </InputRow>
      ),
      [TITLE_ID]: options => (
        <InputRow label={'title'} required={options.required}>
          <select
            name="titleId"
            ref={(ref) => { this.titleId = ref; }}
            value={profile.titleId || undefined}
            onChange={this.onFormSelectChange}
            className="form-control"
            style={styles.slot.select}
            required
          >
            <option value="">-- {i18n.t('select')} --</option>
            {titlesOptions}
          </select>
        </InputRow>
      ),
      [SPECIALTY_ID]: options => (
        <InputRow label={'specialty'} required={options.required}>
          <select
            name="specialtyId"
            ref={(ref) => { this.specialtyId = ref; }}
            value={profile.specialtyId || undefined}
            onChange={this.onFormSelectChange}
            className="form-control"
            style={styles.slot.select}
            required
          >
            <option value="">-- {i18n.t('select')} --</option>
            {specialtiesOptions}
          </select>
        </InputRow>
      ),
      [MEDICAL_GROUP_ID]: options => (
        <InputRow label={'medicalGroup'} required={options.required}>
          <select
            name="medicalGroupId"
            ref={(ref) => { this.medicalGroupId = ref; }}
            value={profile.medicalGroupId || undefined}
            onChange={this.onFormSelectChange}
            className="form-control"
            style={styles.slot.select}
            required
          >
            <option value="">-- {i18n.t('select')} --</option>
            {groupsOptions}
          </select>
        </InputRow>
      ),
    };

    // Filter out the fields to display to the current user
    const toDisplay = profile.roleId && roleFields[profile.roleId].fields.map((fieldName) => {
      const required = roleFields[profile.roleId].requiredFields.includes(fieldName);
      return <div key={fieldName}>{allAvailableFields[fieldName]({ required })}</div>;
    });
    const {
      actions,
      router,
      user: { profile: { avatar } },
    } = this.props;
    // Should add validator for each field
    return (
      <div className="row" style={styles.profile}>
        <Modal
          title={i18n.t('prevAvatar')}
          visible={preview.isVisible}
        >
          <ReactCrop
            src={preview.src}
            crop={preview.crop}
            imageAlt={i18n.t('prevAvatar')}
            imageStyle={styles.preview.image}
            className="img-rounded img-responsive center-block"
            ruleOfThirds
            onImageLoaded={this.handleImageLoaded}
            onChange={this.handleCropChange}
          />
          <div style={styles.avatar.hint}>
            {i18n.t('avatarHint')}
          </div>
          <div className="center-block">
            <button
              type="button"
              onClick={this.onUploadAvatar}
              className="btn btn-info"
              style={styles.preview.button}
            >
              {i18n.t('upload')}
            </button>
            <button
              type="button"
              onClick={this.onPreviewCancel}
              className="btn btn-primary"
              style={styles.preview.button}
            >
              {i18n.t('cancel')}
            </button>
          </div>
        </Modal>
        <h1>
          {i18n.t('myProfile')}
        </h1>
        <div className="col-xs-12 col-sm-12 col-md-12" style={styles.root}>
          <form ref={(ref) => { this.profileForm = ref; }} onSubmit={this.onSubmit}>
            <div className="well well-md" style={styles.inner}>
              <div className="row">
                <div className="col-sm-12 col-md-6">
                  <div className="avatarContainer" style={styles.avatar.container}>
                    <Image
                      alt={i18n.t('avatar')}
                      src={avatar || ''}
                      style={styles.image}
                      defaultImage={defaultAvatarImage}
                      className="img-rounded img-responsive center-block"
                    />
                    <div className="changeAvatarOverlay" style={avatarOverlayStyle} />
                    <div className="changeAvatarContent" style={styles.avatar.content} onClick={this.onPreviewAvatar}>
                      <div>
                        <span className="glyphicon glyphicon-camera" style={styles.avatar.content.camera} />
                        <p>
                          {i18n.t('uploadYourAvatarMsg')}
                        </p>
                      </div>
                    </div>
                    <InputFile
                      actions={actions}
                      ref={(ref) => { this.uploadImage = ref; }}
                      style={styles.button.uploadImage}
                      onSelectFile={this.onSelectFile}
                    />
                  </div>
                  <div style={styles.avatar.hint}>
                    {i18n.t('avatarHint')}
                  </div>
                </div>

                <div className="col-sm-12 col-md-6" style={styles.form}>
                  {toDisplay}
                  <div className="form-group" style={styles.slot.group}>
                    <div className="col-xs-12 col-sm-8 col-md-12 center-block">
                      <div style={styles.button.changePassword}>
                        <Link href="/profile/edit/password" style={styles.link} router={router}>
                          <button type="button" className="btn btn-primary pull-right">
                            {i18n.t('changePwd')}
                          </button>
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="form-group" style={styles.slot.group}>
                    <div className="col-xs-12 col-sm-8 col-md-12 center-block">
                      <button
                        type="submit"
                        className="btn btn-info pull-right"
                        disabled={!this.isButtonEnabled()}
                        style={styles.button.saveProfile}
                      >
                        {i18n.t('saveProfile')}
                      </button>
                      <button
                        type="button"
                        onClick={this.onCancel}
                        className="btn btn-primary pull-right"
                        style={styles.button.cancel}
                      >
                        {i18n.t('cancel')}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </form>

        </div>
      </div>
    );
  }
}

export default connectActionsAndReducers(EditProfileContainer);



// WEBPACK FOOTER //
// ./src/containers/profile/EditProfileContainer.js